export const FILE_MIME_TYPE = {
  RECORD: 'RECORD',
  MASTER_DATA: 'MASTER_DATA',
} as const;

export const DATABASE_TYPE = {
  MANUFACTURE: 'MANUFACTURE',
  PACKAGE: 'PACKAGE',
} as const;

export const PRESIGNED_URL_VIEW_MODE = {
  PREVIEW: 'preview',
  DOWNLOAD: 'download',
} as const;

export type FileMimeType = keyof typeof FILE_MIME_TYPE;
export type DatabaseType = keyof typeof DATABASE_TYPE;
export type PresignedUrlViewMode = keyof typeof PRESIGNED_URL_VIEW_MODE;
